import * as React from "react";
const SvgFiRrEar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22 9.501a9.52 9.52 0 0 1-3.998 7.743c-.999.71-1.835 1.798-2.632 3.425a6 6 0 0 1-2.06 2.34 5.94 5.94 0 0 1-3.304.985 5.97 5.97 0 0 1-3.569-1.163C4.884 21.674 4 19.911 4.011 17.994a1 1 0 0 1 1-.994h.006a1 1 0 0 1 .994 1.006 3.96 3.96 0 0 0 1.621 3.222c1.32.983 3.198 1.033 4.563.12a3.96 3.96 0 0 0 1.377-1.559c.95-1.938 1.988-3.264 3.27-4.175a7.51 7.51 0 0 0 3.157-6.113 7.52 7.52 0 0 0-2.504-5.594c-1.614-1.44-3.693-2.099-5.87-1.857-3.335.375-6.09 3.056-6.55 6.375a8 8 0 0 0-.063 1.517 1 1 0 0 1-.94 1.056 1.007 1.007 0 0 1-1.056-.94 9.7 9.7 0 0 1 .078-1.909C3.68 3.94 7.174.54 11.404.063a9.54 9.54 0 0 1 7.425 2.353A9.52 9.52 0 0 1 22 9.501m-9.5-3.5c1.93 0 3.5 1.57 3.5 3.5a1 1 0 1 0 2 0c0-3.033-2.468-5.5-5.5-5.5-2.823 0-5.186 2.102-5.494 4.89A1 1 0 0 0 7 9c0 1.297 1.03 2 2 2a1.001 1.001 0 0 1 0 2 1 1 0 0 0 0 2c1.654 0 3-1.346 3-3a3.003 3.003 0 0 0-2.992-3c.245-1.718 1.728-3 3.492-3"
    />
  </svg>
);
export default SvgFiRrEar;
